// extracted by mini-css-extract-plugin
export default {"hideTooltip":"x--z","fadeIn":"y--z","delay":"z--z","recommendedSizeTooltip":"A--z"};